import { AxiosResponse, CancelToken } from 'axios';
import { AGraphWrappedType, unwrapAGraphResponse } from '../../utils/AGraphWrapper';
import { apbApi } from './Base';

export type FXRates = { [key: string]: number };

export async function getFx(
  params: { date: string; pkg: string },
  cancelToken?: CancelToken
): Promise<AxiosResponse<FXRates>> {
  const path = 'api/v4/fx';
  const response = await apbApi.get<AGraphWrappedType<FXRates, 'fxRates'>>(path, { params, cancelToken });
  return unwrapAGraphResponse(response, 'fxRates');
}
